import { useState } from 'react';
import TranslationPageLayout from '../../Components/shared/TranslationPageLayout.js';
import CommonImage from '../../Components/shared/ImageComponent';
// import Footer from '../../Components/shared/Footer';
import { legalDocumentTranslationData } from '../../Components/shared/faqList';
import FAQ from '../../Components/shared/FAQ';
// import Navbar from '../../Components/shared/Header';
import { IMAGES } from "./imagesImports";
import {
    section2Images,
    section3Images,
    section5Images,
    section6Images,
    section7Images,
} from "./imagesItem"
import "./index.css"
import HorizontleButtons from '../../Components/shared/HorizontleButtons.js';
import { useHorizontalScroll } from "../../Hooks/useHorizontalScroll.js";
import SignInForm from '../SignIn/SignInForm.js';
import CreateAccount from '../CreateAccount/CreateAccount';
import { useLocation } from 'react-router-dom';
import Navbar from '../HomePage/header.js';
import Footer from '../HomePage/footer.js';

const LegalDocumentTranslationPage = ({ windowSize }) => {
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
    const {
        scrollRef: section5LegalRef,
        scrollLeft: section5Left,
        scrollRight: section5Right,
    } = useHorizontalScroll(300);

    const {
        scrollRef: section7LegalRef,
        scrollLeft: section7Left,
        scrollRight: section7Right,
    } = useHorizontalScroll(300);

    const handleLoginOpen = (newState) => {
        setIsModalOpen(newState);
    };

    const handleCreateAccountOpen = (newState) => {
        setIsCreateAccountOpen(newState);
    };

    return (
        <TranslationPageLayout>

            <SignInForm
                open={isModalOpen}
                isLoginFormOpen={handleLoginOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
            />
            <CreateAccount
                open={isCreateAccountOpen}
                isCreateAccountOpen={handleCreateAccountOpen}
                isLoginFormOpen={handleLoginOpen}
            />

            {/* Hero section */}
            <div role='Hero-frame' className='legal-hero-frame w-full'>
                <div className='legal-hero'>
                    {/* <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen} defaultPath={pathname}/> */}
                    <Navbar
                        windowSize={windowSize}
                        isLoginFormOpen={handleLoginOpen}
                        border={true}
                    />
                    <div role='content-section' className='legal-contentSection items-center justify-center'>
                        <div
                            style={{ maxWidth: '568px' }}
                            className='lex flex-col gap-6'
                            role='left-section-large-text'
                        >
                            <div className='legal-combineLargeText'>
                                <p className='legal-largeText legal-orange-text  text-5xl  md:text-6xl lg:text-[80px]'>Legal Document</p> <br />
                                <p className='legal-largeText legal-dark-blue-text text-5xl  md:text-6xl lg:text-[80px]'>Translation Services by</p><br />
                                <p className='legal-largeText legal-green-text text-5xl  md:text-6xl lg:text-[80px]'>eVerbary</p>
                            </div>
                            <p className='legal-smallText'>At eVerbary, we provide legal document translation services that meet the highest industry standards. When accuracy, turnaround time, and confidentiality matter most, our certified translation team delivers. We help law firms, corporate legal departments, and individuals translate documents from one language to another with precision and professionalism.</p>
                        </div>
                        <div role='right-section-image-container' className='hidden md:block'>
                            <img
                                src={IMAGES.LEGAL_TRANSLATION_IMG}
                                alt="Logo eVerbary"
                            />
                        </div>
                    </div>
                    <div role='hero-bottom-section' className='legal-heroBottomSection'>
                        Whether you need to translate contracts, court records, immigration documents, or other legal files, our certified legal translation service ensures your documents are translated and certified by a professional translator in 65+ languages, including Spanish.
                    </div>
                </div>
            </div>

            {/* Why Legal Document Translation Is Essential */}
            <div className='legal-section2'>
                <div role='section2-header' className='legal-section2Header'>
                    <span className='legal-section2HeaderHeading'>Why Legal Document Translation Is Essential</span>
                    <span className='legal-section2HeaderText'>USCIS requires certified translations for all official documents not originally written in English. These include personal documents like birth certificates, certificates of marriage, diplomas, and other records used for immigration applications.</span>
                </div>
                <div role="section2-Image" className="legal-section2Images">
                    {section2Images.map((item, index) => (
                        <div
                            key={index}
                            style={{ backgroundImage: `url(${item?.src})` }}
                            className='legal-section2ImageItem'
                        >
                            <div className='imm-sec2-text'>{item?.text}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Our Certified Legal Translation Process */}
            <div className='w-full'>
                <div className='legal-section3'>
                    <div role='section3-header' className='legal-section3Header'>
                        <span className='legal-section3HeaderHeading'>Our Certified Legal Translation Process</span>
                        <span className='legal-section3HeaderText'>Our translation process is built to deliver reliable and accurate results quickly: </span>
                    </div>
                    <div role='section3-Images-and-text' className='legal-section3ImagesAndText'>
                        <div role="section3-Images" className="legal-section3Images">
                            {section3Images.map((item, idx) => (
                                <div
                                    key={idx}
                                    style={{ 
                                        maxWidth: windowSize.width < 640 ? '100%' : '248px',
                                        minHeight: windowSize.width < 640 ? '246px' : '372px',
                                        background : `${item?.backgroundColor}`
                                    }}
                                    className='immigration-section5ImageItem relative'
                                >
                                    <img className='rounded-4xl sm:w-auto w-[200px]' src={item?.src} />
                                    <div className='flex flex-col pr-[15px] self-start absolute bottom-6'>
                                        <span className='imm-sec5-heading'>{item?.heading}</span>
                                        <span className='imm-sec5-desc'>{item?.description}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <span role='section3-Images-text' className='legal-section3ImagesText'>The entire process is handled by native speakers and certified translators who understand the nuances of legal language</span>
                    </div>
                </div>
            </div>

            {/* What Legal Documents Can Be Translated? */}
            <div className='legal-section4'>
                <div className='legal-section4Content'>
                    <div className='legal-section4HeadingAndText'>
                        <p className='legal-section4Heading'>What Legal Documents Can Be Translated?</p>
                        <p className='legal-section4CenterText'>We translate a wide range of documents for USCIS, including:</p>
                    </div>
                    <p className='legal-section4BottomText'>If your documents need to be certified and notarized, we handle that too. We can certify the translation and provide a notarized translation for official use.</p>
                </div>
                <img
                    className='md:block hidden absolute top-0 right-0 object-contain inset-0 h-full w-full'
                    src={IMAGES.LEGAL_SECTION4_MOBILEIMG}
                />
                <img
                    className='md:hidden block'
                    src={IMAGES.LEGAL_SECTION4_MOBILEIMG}
                />
            </div>

            {/* Certified Translation Services That Meet Legal Requirements */}
            <div className='w-full'>
                <div className='legal-section5'>
                    <div role='section5-header' className='legal-section5Header'>
                        <div className='legal-section5HeaderHeading'>Certified Translation Services That Meet Legal Requirements</div>
                        <div className='legal-section5HeaderText'>Many institutions require a certified translation, especially for immigration and legal proceedings. Our certified translation service includes:</div>
                    </div>
                    <div ref={section5LegalRef} role="section5-Images" className="legal-section5Images scrollbar-hide">
                        {section5Images?.map((item, index) => (
                            <div className="legal-section5Image" key={index}>
                                <CommonImage src={item?.src} alt={item?.alt} width={56} height={56} />
                                <div className="legal-imageBottomText">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section5Left}
                        scrollRight={section5Right}
                        type='blue'
                    />
                    <span role='section5-bottom-text' className='legal-section5HBottomText'>You can trust that our certified translations meet USCIS, court, and legal industry standards.</span>
                </div>
            </div>

            {/* Why Choose eVerbary for Legal Translation Services? */}
            <div className='legal-section6'>
                <div className='legal-section6Container'>
                    <div className='legal-section6Header'>
                        <div className='legal-section6HeaderHeading'>Why Choose eVerbary for Legal Translation Services?</div>
                        <div className='legal-section6HeaderText'>Choosing the right translation provider is crucial for legal work. At eVerbary, we stand apart with:</div>
                    </div>
                    <div className="legal-section6Images">
                        {section6Images?.map((item, index) => (
                            <div className="legal-section6Image" key={index}>
                                <CommonImage src={item?.src} width={60} alt={item?.alt} />
                                <div className="legal-imageBottomText legal-imageBottomTextWhite">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <div className='legal-section6BottomText'>We don’t oversell services. We provide legal support with certified translation that delivers measurable results.</div>
                </div>
            </div>

            {/* Translation Services Tailored to the Legal Industry */}
            <div className='legal-section7'>
                <div className='legal-section7Container'>
                    <div className='legal-section7Header'>
                        <span className='legal-section7HeaderHeading'>Translation Services Tailored to the Legal Industry</span>
                        <span className='legal-section7HeaderText'>We understand the legal industry and provide language services that meet the needs of legal professionals. Whether you're dealing with global legal matters or local litigation, our legal document translation services ensure your files are legally sound in the target language. Our services include:</span>
                    </div>
                    <div ref={section7LegalRef} className="legal-section7Images scrollbar-hide">
                        {section7Images?.map((item, index) => (
                            <div className="legal-section7Image" key={index}>
                                <CommonImage src={item?.src} width={32} alt={item?.alt} />
                                <div className="legal-imageBottomText">{item?.text}</div>
                            </div>
                        ))}
                    </div>
                    <HorizontleButtons
                        scrollLeft={section7Left}
                        scrollRight={section7Right}
                        type='blue'
                    />
                    <div className='legal-section7HBottomText'>We support legal teams and law firms with professional document translation, ensuring your original document is faithfully reproduced in another language.</div>
                </div>
            </div>

            {/*Legal Translation for Law Firms and Corporate Legal Departments */}
            <div className='w-full bg-[#7245ED] rounded-4xl'>
                <div className='legal-section8'>
                    <div className='legal-section8Content'>
                    <span className='legal-section8ContentHeading'>Legal Translation for Law Firms and Corporate Legal Departments</span>
                    <span className='legal-section8ContentCenterText'>Our translation company serves law firms and corporate legal departments across the U.S. We help legal experts manage cross-border cases, contracts, and filings with language services that are compliant and cost-effective.</span>
                    <span className='legal-section8ContentBottomText'>With translation accuracy as our top priority, you can count on us to translate documents that hold up in any legal setting.</span>
                    </div>
                    <div className='legal-section8Img'>
                        <img src={IMAGES.PIC} alt='section8-image' />
                    </div>
                </div>
            </div>

            {/* FAQ */}
            <FAQ id='faqs-legal' faqData={legalDocumentTranslationData} />

            {/* Get Your Legal Documents Translated Today */}
            <div className='legal-section10'>
                <div className='legal-section10Heading'>Get Your <span style={{ color: '#F46350' }}>Legal Documents </span> <br />
                    Translated Today</div>
                <div className='legal-section10CenterText'>If you need translation services for your legal documents, eVerbary is ready to help. We offer expert legal translation in over 65 languages, including Spanish, Portuguese, Russian, Ukrainian, Arabic, Farsi, Chinese, and Hindi, with turnaround times designed to meet your schedule.</div>
                <div className='legal-section10BottomText'>Whether you're handling legal proceedings, preparing immigration filings, or drafting international contracts, our team delivers the certified, professional translation you can trust. Upload your documents, get your legal files translated by a professional translator, and receive your certified translation, all with speed, precision, and complete confidentiality.</div>
            </div>

            {/* Footer */}
            {/* <Footer windowSize={windowSize} defaultPath={pathname} /> */}
            <Footer windowSize={windowSize} />
        </TranslationPageLayout>
    )
}

export default LegalDocumentTranslationPage